import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';

const StyledItaliaButton = styled(Button)`
  &&& {
    display: inline-block;
    position: relative;
    padding: 0;
    color: #fff;
    font-family: 'Titillium Web', HelveticaNeue, Helvetica Neue, Helvetica,
      Arial, Lucida Grande, sans-serif;
    font-weight: 600;
    line-height: 1em;
    text-decoration: none;
    border: 0;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    font-size: 15px;
    width: 230px; // aumentato per inserire Login with eIDAS (era 220px);
    background-color: #06c;
    svg {
      fill: #fff;
    }
    & > span img {
      width: 29px;
      height: 29px;
      border: 0;
    }

    &.ant-btn {
      // white-space: unset;
      // background-image: unset;
      height: auto;
      box-shadow: unset;
      // background: unset;

      &:hover {
        background-color: #036;
        color: #fff;
      }
      &:active {
        background-color: #83beed;
        color: #036;
      }
      &:focus {
        background-color: #036;
        color: #fff;
      }
    }
  }
`;

const ItaliaButtonIco = styled.span`
  display: block;
  float: left;
  margin: 0; // -0.4em 0 0;
  padding: 0.6em 0.8em 0.5em;
  border-right: rgba(255, 255, 255, 0.1) 0.1em solid;
`;

const ItaliaButtonText = styled.span`
  display: block;
  float: left;
  padding: 0.95em 1em 0.85em 1.4em;
  padding-inline: 0;
  margin-left: 0.5em;
  font-size: 1.15em;
  text-align: center;
`;

export interface ItaliaButtonProps extends ButtonProps {
  image: any;
  text: string;
  alt?: string;
}

/**
 * Pulsante conn gli stili Italia dell'Agid (Spid)
 */
export function ItaliaButton(props: ItaliaButtonProps) {
  const { image, text, alt, ...buttonProps } = props;

  return (
    <StyledItaliaButton {...buttonProps}>
      <ItaliaButtonIco>
        <img src={image} alt={alt} aria-hidden={alt ? undefined : 'true'} />
      </ItaliaButtonIco>
      <ItaliaButtonText>{text}</ItaliaButtonText>
    </StyledItaliaButton>
  );
}
